import { appstr } from "../utils/appstr";
import {
  enumKeyboardTargetEnterAction,
  enumPanelBorderStyle,
  enumShortCutModKeys,
  kCustomExcelWidth,
  kEnterOKShortCut,
  kStdPickerBkgrnd,
  kTabKey
} from "../constants";
import { QCustomExcelBorder } from "./QCustomExcelBorder";
import { QExcelFieldElement } from "./QExcelFieldElement";
import { QPanel } from "./QPanel";
import { AddStdButtonAutoPos } from "../utils/AddStdButtonAutoPos";

export class QCustomExcelExport extends QPanel {
  constructor() {
    super();
    this.fWSMgr = null;
  }

  InitCustomExcel(wsMgr) {
    this.fWSMgr = wsMgr;
    var panelHeight = 600;
    this.SizePanel(kCustomExcelWidth, panelHeight);
    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(true);
    this.SetFillColor(kStdPickerBkgrnd);
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);

    var indent = 10;

    var boxLeft = new QCustomExcelBorder();
    boxLeft.InitBorderElement(this, indent, indent, 50, 100);

    var boxRight = new QCustomExcelBorder();
    boxRight.InitBorderElement(this, 200, indent, 50, 100);

    var fieldList = ["ABC", "EFG", "123", "456"];
    this.PopulateFieldElements(fieldList);

    var buttonHeight = 20;
    var buttonMargin = indent;
    var butWidth = 50;
    var yPos = panelHeight - 30;

    var xRight = kCustomExcelWidth - buttonMargin;
    var okBut = AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("OK"),
      null,
      null,
      false,
      "OKCustomExcel"
    );
    okBut.SetCmdShortCut(kEnterOKShortCut, enumShortCutModKeys.none, "");

    xRight = okBut.GetPositionX() - buttonMargin;
    AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("Cancel"),
      null,
      null,
      false,
      "CancelCustomExcel"
    );

    var helpButton = this.AddHelpButton("customexcel_help", true);
    helpButton.AutoPosition();
  }

  PopulateFieldElements(fieldList) {
    var n = fieldList.length;
    var yPos = 100;
    var xPos = 100;
    for (var i = 0; i < n; i++) {
      var fieldElement = new QExcelFieldElement();
      fieldElement.InitFieldElement(this, xPos, yPos, 50, 100, fieldList[i]);
      yPos = yPos + 20;
    }
  }

  BecomeKeyboardTarget() {
    var wsMgr = this.fWSMgr;
    wsMgr.SetKeyboardTarget(null, this, enumKeyboardTargetEnterAction.selectAll);
  }

  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    var handled = true;
    var keyCode = keyInfo.keyCode;

    switch (keyCode) {
      case kTabKey:
        this.TabToNextElement(!keyInfo.shiftKey, targetElement, wsMgr);
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = false;

    switch (cmdCode) {
      case "OKCustomExcel":
        // Do stuff!
        panelHandled = true;
        break;
      case "CancelCustomExcel":
      case "CNCL":
        panelHandled = true;
        wsMgr.RemovePanel(this);
        break;
      default:
        panelHandled = false;
        break;
    }

    return panelHandled;
  }
}
